"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component = _interopRequireDefault(require("../../Component"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _main = _interopRequireDefault(require("../templates/main"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _syntheticEvent = _interopRequireDefault(require("../../../utils/syntheticEvent"));

var _prepareDynamicChildren = _interopRequireDefault(require("../../../utils/prepareDynamicChildren"));

var Main =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(Main, _View);

  function Main(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Main);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_listRef", function (el) {
      return _this.list = el;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_labelRef", function (el) {
      _this._labels = _this._labels || {};

      if (el !== null) {
        _this._labels[el.getAttribute('data-id')] = el;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_externalRef", function (el) {
      if (typeof _this.props.elementRef === 'function') {
        _this.props.elementRef(el);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          autoFocus = _this$props.autoFocus;

      if (typeof onChange === 'function') {
        _this.props.onChange(event);
      }

      if (autoFocus && event.target.value) {
        _this._labels[event.target.value].scrollIntoView({
          block: 'center',
          behavior: 'smooth',
          inline: 'center'
        });
      }
    });
    var collection = props.collection ? _this._processCollection(props.collection) : props.children;
    _this.state = {
      id: (0, _uniqueId["default"])('toggler_'),
      list: (0, _prepareDynamicChildren["default"])(collection)
    };
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(prevProps, prevState) {
        var _this$props2, children, collection, value, list, selected;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props2 = this.props, children = _this$props2.children, collection = _this$props2.collection, value = _this$props2.value;

                if (!(collection !== prevProps.collection || children !== prevProps.children)) {
                  _context.next = 7;
                  break;
                }

                list = collection ? this._processCollection(collection) : children;
                _context.next = 5;
                return this.setState({
                  list: (0, _prepareDynamicChildren["default"])(list)
                });

              case 5:
                selected = this._getSelected();

                if (value !== null && value !== undefined && value !== '' && !selected) {
                  this.value = null;
                }

              case 7:
                if (this.props.value !== prevProps.value) {
                  this.setMaskPosition();
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x, _x2) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // update mask position
      this.setMaskPosition();

      this._externalRef(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(Main.prototype), "componentWillUnmount", this).call(this);

      this._externalRef(null);
    }
  }, {
    key: "_getSelected",
    value: function _getSelected() {
      var _this2 = this;

      var list = this.state.list; // без точного приведения типов, потому что в модель может записаться стринг после ввода через инпут

      return list ? list.find(function (item) {
        return _this2.props.value == item.id;
      }) : null;
    }
  }, {
    key: "setMaskPosition",
    value: function setMaskPosition() {
      var position = {};

      var selected = this._getSelected();

      if (this._labels && selected && this._labels[selected.id]) {
        var el = this._labels[selected.id];
        position = {
          transform: "translateX(".concat(el.offsetLeft, "px)"),
          width: el.offsetWidth
        };
      }

      return this.setState({
        position: position
      });
    }
  }, {
    key: "value",
    get: function get() {
      return this.props.value;
    },
    set: function set(value) {
      var target = {
        value: value,
        type: 'input',
        name: this.props.name
      };

      if (typeof this.props.onChange === 'function') {
        this.props.onChange((0, _syntheticEvent["default"])(target));
      }
    }
  }]);
  return Main;
}(_Component["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  autoFocus: false
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  label: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  attribute: _propTypes["default"].string,
  children: _propTypes["default"].any,
  value: _propTypes["default"].any,
  autoFocus: _propTypes["default"].bool,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.tInactive
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default 1.5
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.elDivider
     */
    borderColor: _propTypes["default"].string,

    /**
     * @default solid
     */
    borderStyle: _propTypes["default"].string,

    /**
     * @default 1px
     */
    borderWidth: _propTypes["default"].string,

    /**
     * @default palette.elPrimary
     */
    background: _propTypes["default"].string,

    /**
     * @default 4px ${palette.gutter * 2}px
     */
    padding: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 27px
     */
    borderRadius: _propTypes["default"].string,

    /**
     * @default none
     */
    boxShadow: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    hoverColor: _propTypes["default"].string,

    /**
     * @default palette.elPrimary
     */
    hoverBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    hoverBoxShadow: _propTypes["default"].string,

    /**
     * @default palette.tActive
     */
    activeColor: _propTypes["default"].string,

    /**
     * @default palette.elPrimary
     */
    activeBackground: _propTypes["default"].string,

    /**
     * @default none
     */
    activeBoxShadow: _propTypes["default"].string,

    /**
     * @default palette.tLabel
     */
    labelColor: _propTypes["default"].string,

    /**
     * @default palette.tsXSmall
     */
    labelFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlXSmall
     */
    labelLineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tInversion
     */
    maskColor: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    maskBackground: _propTypes["default"].string,

    /**
     * @default 0 2px 4px 0 ${palette.elShadowMain}
     */
    maskBoxShadow: _propTypes["default"].string,

    /**
     * @default solid
     */
    maskBorderStyle: _propTypes["default"].string,

    /**
     * @default transparent
     */
    maskBorderColor: _propTypes["default"].string,

    /**
     * @default palette.tInversion
     */
    hoverMaskColor: _propTypes["default"].string,

    /**
     * @default hoverColor
     */
    hoverMaskBackground: _propTypes["default"].string,

    /**
     * @default 0 2px 4px 0 ${palette.elShadowMain}
     */
    hoverMaskBoxShadow: _propTypes["default"].string,

    /**
     * @default solid
     */
    hoverMaskBorderStyle: _propTypes["default"].string,

    /**
     * @default transparent
     */
    hoverMaskBorderColor: _propTypes["default"].string,

    /**
     * @default palette.tError
     */
    errorLabelColor: _propTypes["default"].string,

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'Toggler');
var _default = Main;
exports["default"] = _default;